import { CodeYellow } from "./CodeYellow";
import { AuthUser } from "./CurrentUser";
import { Group } from "./Group";

export enum WorklistType {
  GROUP = "group",
  PERSONAL = "personal",
}

export interface Worklist {
  id: string;
  type: WorklistType;
  usdPerRvu: number;
  userId?: string;
  user?: AuthUser;
  groupId?: string;
  group?: Group;
  codeYellows: CodeYellow[];
}
